import React, { useEffect, useState } from "react";
import BasePage from "../../../Components/Base/BasePage";
import axios from "axios";
import CardControleDocaComponent from "./CardControleDocaComponent";
import CardControleDocaHeaderComponent from "./CardControleDocaHeaderComponent";
import DropDownListComponent from "../../../Components/Forms/DropDownListComponent";
import ConfirmPopup from "../../../Components/Forms/ConfirmPopup";
import { faCheck, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from "@mui/material";
import TextInputPopup from "../../../Components/Forms/TextInputPopup";
import DropDownInputPopup from "../../../Components/Forms/DropDownInputPopup";
import ControleDocaDetalheViagemPopup from "./ControleDocaDetalheViagemPopup";
import { useSnackbar } from "notistack";

let timerPainelControleDoca: NodeJS.Timeout;

const ControleDocaPage = (props: any) => {
    const [loading, setLoading] = useState(false);
    const [isOpenMotivoClickPausa, setIsOpenMotivo] = useState(false);    
    const [isOpenDocumentoClickVeiculo, setIsOpenDocumento] = useState(false);    
    const [isOpenFinalizaDocaClickPlaca, setIsOpenFinalizaDoca] = useState(false);    
    const [isOpenIniciarDocaClickCard, setIsOpenIniciarDoca] = useState(false);    
    const [isOpenDetalhe, setIsOpenDetalhe] = useState(false);    
    const [docaSelecionada, setDocaSelecionada] = useState<any>({});
    const [docas, setDocas] = useState<any>([]);
    const [horarios, setHorarios] = useState<any>([]);
    const [empresas, setEmpresas] = useState<any[]>([]);
    const { enqueueSnackbar } = useSnackbar();
    const [isPageLoaded, setIsPageLoaded] = useState(false);    

    const [empresaSelecionada, setEmpresaSelecionada] = useState<any>({});
    const [configuracaoPagina, setConfiguracaoPagina] = useState<any>({});

    useEffect(() => {(async () => await inicializaAsync())()}, []);
    useEffect(() => {(async () => await botaoEmpresaClickAsync())()}, [empresaSelecionada]);
    useEffect(() => atribuiConfiguracaoPagina(), [configuracaoPagina]);

    async function inicializaAsync()
    {
        setLoading(true);
        
        try {
            loadStylePage();
            await carregaEmpresasAsync();
            const empresaControleDocaSelecionada = localStorage.getItem("empresaControleDocaSelecionada");
            let empresa = empresaControleDocaSelecionada ? JSON.parse(empresaControleDocaSelecionada) : [];
            setEmpresaSelecionada(empresa);
            
            localRecursiveEventAsync();
        }
        catch(ex) {
            enqueueSnackbar('Erro!', { variant: 'error' });
            console.log(ex);
        }
        finally {
            setIsPageLoaded(true);
            setLoading(false);
        }
    }

    async function loadStylePage() {
        let page = document.getElementById("main-height");
        if (page!=null) {
          page.setAttribute('style', 'background-color:#FFF !important');
        }
        
        let response: any = await axios.get(`controleDocaConfiguracao`);
        if (response.data != null && response.data != "") {
          setConfiguracaoPagina(response.data);
         
          //if (page!=null && (configuracaoPagina.cor_fundo??'') != '')
  
        }
    }
  
    function atribuiConfiguracaoPagina() {
      setTimeout( () =>  {
      console.log(configuracaoPagina);
        let centralPage = document.getElementsByClassName("central-page")
        for (let index = 0; index < centralPage.length; index++) {
          centralPage[index]?.setAttribute('style', `background-color:${configuracaoPagina.cor_fundo} !important`);
        }
  
        // let cardGroup = document.getElementsByClassName("card-group")
        // for (let index = 0; index < cardGroup.length; index++) {
        //   centralPage[index]?.setAttribute('style', `background-color:${configuracaoPagina.cor_fundo} !important`);
        // }
        //document.getElementsByClassName("central-page")[1]?.setAttribute('style', `background-color:${configuracaoPagina.cor_fundo} !important`);
        document.getElementById("main-height")?.setAttribute('style', `background-color:${configuracaoPagina.cor_fundo} !important`);
        document.getElementsByTagName("body")[0].setAttribute('style', `background-color:${configuracaoPagina.cor_fundo} !important`);
      }, 1000);
    }
    
    async function carregaEmpresasAsync() {      
        try {    
            let empresas = await axios.get('painelControleDoca/empresasSelecao');
            empresas.data.unshift({id:'', razao_social:'-'});
            setEmpresas(empresas.data);
        }
        catch(ex) {
            enqueueSnackbar('Erro!', { variant: 'error' });
            console.log(ex);
        }
    }

    async function botaoEmpresaClickAsync()
    {
        if(!isPageLoaded) {
            return;
        }
        
        setLoading(true);
        
        try {
            localStorage.setItem("empresaControleDocaSelecionada", JSON.stringify(empresaSelecionada));
            setEmpresaSelecionada(empresaSelecionada);

            await localRecursiveEventAsync();
        }
        catch(ex) {
            enqueueSnackbar('Erro!', { variant: 'error' });
            console.log(ex);
        }
        finally {
            setLoading(false);
        }
    }
    
    async function carregadaDadosHorariosEDocasAsync() {
        if ((empresaSelecionada?.id??'') == '') {
            setHorarios([]);
            setDocas([]);
            return;
        }
        
        await carregaHorariosAsync(empresaSelecionada.id);
        await carregaDocasAsync(empresaSelecionada.id);
    }

    async function carregaHorariosAsync(empresa_id:number) {        
        let horarios = await getHorariosAsync(empresa_id);
        setHorarios(horarios);
    }

    const getHorariosAsync = async (empresa_id:number) => {
        try {  
            document.body.style.cursor = "progress";
            let response:any = await axios.get(`painelControleDoca/horarios?empresa_id=${empresa_id}`);
            document.body.style.cursor = "default";
            return response.data;
        }
        catch(ex) {
            enqueueSnackbar('Erro!', { variant: 'error' });
            console.log(ex);
        }
    };

    async function carregaDocasAsync(empresa_id:number) {
        try {       
            let docas = await getDocasAsync(empresa_id);
            setDocas(docas ?? []);
        }
        catch(ex) {
            enqueueSnackbar('Erro!', { variant: 'error' });
            console.log(ex);
        }
    }

    const getDocasAsync = async (empresa_id:number) => {
        try {       
            document.body.style.cursor = "progress";
            let response:any = await axios.get(`painelControleDoca/carregaDocas?empresa_id=${empresa_id}`);
            document.body.style.cursor = "default";
            return response.data;
        }
        catch(ex) {
            enqueueSnackbar('Erro!', { variant: 'error' });
            console.log(ex);
            return null;
        }
    };

    async function localRecursiveEventAsync() {
        clearTimeout(timerPainelControleDoca);
        
        try {            
            await carregadaDadosHorariosEDocasAsync();

            timerPainelControleDoca = setTimeout(async () => await  localRecursiveEventAsync(), 60000);
        }
        catch (ex) {
            timerPainelControleDoca = setTimeout(async () => await localRecursiveEventAsync(), 30000);
        }
    }

    function pauseClickInformeMotivo(doca:any) {
        setIsOpenMotivo(true);
        setDocaSelecionada(doca);
    }

    async function pauseControleDocaConfirmMotivoAsync(motivo:string)
    {    
        setLoading(true);
        
        try {
            motivo ??= '';
            await axios.post('painelControleDoca/pause', {doca_selecionada_id:docaSelecionada.id, motivo:motivo});
            await localRecursiveEventAsync();
            enqueueSnackbar('Doca em Pausa!', {variant: 'success'});
        }
        catch(ex) {
            enqueueSnackbar('Erro!', { variant: 'error' });
            console.log(ex);
        }
        finally {
            setLoading(false);
        }
    }

    async function playAgainClickControleDocaAsync(docaSelecionada:any)
    {
        setLoading(true);
        
        try {
            setDocaSelecionada(docaSelecionada);
            await axios.post('painelControleDoca/reinicia', {doca_selecionada_id:docaSelecionada.id}); 
            await localRecursiveEventAsync();
            enqueueSnackbar('Doca Reiniciada!', {variant: 'success'});
        }
        catch(ex) {
            enqueueSnackbar('Erro!', { variant: 'error' });
            console.log(ex);
        }
        finally {
            setLoading(false);
        }
    }

    function placaClickOpenDetalhe(doca:any) {
        if ((doca.placa??'') == '') {
            return;
        }

        setDocaSelecionada(doca);   
        setIsOpenDetalhe(true);
    }

    function cardClickIniciaDoca(doca:any)
    {
        if ((doca.placa??'') != '') {
            return;
        }

        setDocaSelecionada(doca);
        setIsOpenIniciarDoca(true);
    }

    async function cardClickIniciaDocaConfirmAsync(veiculo_id:any)
    {
        await iniciaDoca(veiculo_id);
    }

    function veiculoClickInformeDocumento(doca:any)
    {
        setDocaSelecionada(doca);
        setIsOpenDocumento(true);
    }

    async function documentoConfirmAsync(documento:string)
    {
        setLoading(true);
        
        try {
            await axios.post('painelControleDoca/atualizaDocumento', {doca_selecionada_id:docaSelecionada.id, documento:documento}); 
            await localRecursiveEventAsync();
        }
        catch(ex) {
            enqueueSnackbar('Erro!', { variant: 'error' });
            console.log(ex);
        }
        finally {
            setLoading(false);
        }
    }

    async function iniciaDoca(veiculo_id:number)
    {
        setLoading(true);

        try {
            await axios.post('painelControleDoca/iniciaDoca', {doca_selecionada_id:docaSelecionada.id, veiculo_id:veiculo_id}); 
            
            await localRecursiveEventAsync();
            
            let length = docas?.length ?? 0;
            for (let index = 0; index < length; index++) {
                const element = docas[index];
                if (element.id == docaSelecionada.id)
                {
                    setDocaSelecionada(element);
                }
                
            }

            setIsOpenDocumento(true);
            enqueueSnackbar('Doca Iniciada!', {variant: 'success'});
        }
        catch(ex) {
            enqueueSnackbar('Erro!', { variant: 'error' });
            console.log(ex);
        }
        finally {
            setLoading(false);
        }
    }

    function topCardClickFinalizaDoca(doca:any)
    {
        if ((doca.placa??'') == '') {
            return;
        }

        setDocaSelecionada(doca);
        setIsOpenFinalizaDoca(true);
    }

    async function finalizaDocaConfirm()
    {
        setLoading(true);

        try {
            await axios.post('painelControleDoca/finalizaDoca', {doca_selecionada_id:docaSelecionada.id});
            await localRecursiveEventAsync();
            enqueueSnackbar('Doca Finalizada!', {variant: 'success'});
        }
        catch(ex) {
            enqueueSnackbar('Erro!', { variant: 'error' });
            console.log(ex);
        }
        finally {
            setLoading(false);
            setIsOpenFinalizaDoca(false)
        }
    }

    return (
        <BasePage loading={loading}>
            <main style={{marginLeft:-10, textAlign:'start'}}>
                
                <div className="row">
                    <div className="row col-lg-4 col-md-12 col-sm-11 col-10 mb-3 p-3">
                        <div className="col-lg-10 col-md-10 col-sm-10 col-10">
                            <DropDownListComponent
                                label='Empresa'
                                required
                                options={empresas}
                                valueField='id'
                                textField='razao_social'
                                model={empresaSelecionada}
                                modelField='id' />
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                            <Button variant="contained" color="info" style={{height:'55px', marginLeft: '-15px'}} onClick={async() => await botaoEmpresaClickAsync()}>
                                <FontAwesomeIcon icon={faRefresh} size={"xl"} style={{marginLeft: '10px'}} />
                            </Button>
                        </div>
                    </div>
                        
                    <section className="card-group card-group-header-docas col-lg-8 col-md-11 col-sm-12 col-12">
                        {(horarios ?? [])?.map((e: any) => (
                            <CardControleDocaHeaderComponent 
                                horario={e}
                                key={`key-ccdhc-${e.id}`}
                            />
                        ))}
                    </section>
                </div>

                <section className="card-group">
                    {(docas??[])?.map((e: any) => (
                        <CardControleDocaComponent 
                            dadosDoca={e}
                            key={`key-ccdc-${e.id}`}
                            topCardClick={(doca:any) => topCardClickFinalizaDoca(doca)}
                            cardClick={(doca:any) => cardClickIniciaDoca(doca)}
                            pauseClick={(doca:any) => pauseClickInformeMotivo(doca)}
                            playAgainClick={async (doca:any) => await playAgainClickControleDocaAsync(doca)}
                            placaClick={(doca:any) => placaClickOpenDetalhe(doca)}
                            veiculoClick={(doca:any) => veiculoClickInformeDocumento(doca)}
                        />
                    ))}
                </section>
            </main>

            {isOpenDetalhe ? <ControleDocaDetalheViagemPopup isOpen={isOpenDetalhe} onClose={() => setIsOpenDetalhe(false)} docaSelecionada={docaSelecionada} /> : ''}
            {isOpenIniciarDocaClickCard ? <DropDownInputPopup label="Veiculo" textField="placa" urlApi="painelControleDoca/veiculosDisponiveis" titulo="Informe um veiculo para iniciar a doca:" isOpen={isOpenIniciarDocaClickCard} onConfirmAction={cardClickIniciaDocaConfirmAsync} onCloseAction={() => setIsOpenIniciarDoca(false)} /> : ''}
            {isOpenDocumentoClickVeiculo ? <TextInputPopup labelConfirm="Continuar" titulo="Deseja inserir o documento do cliente?" defaultValue={docaSelecionada.documento} isOpen={isOpenDocumentoClickVeiculo} onConfirmAction={documentoConfirmAsync} onCloseAction={() => setIsOpenDocumento(false)} /> : ''}
            {isOpenMotivoClickPausa ? <TextInputPopup titulo="Informe o motivo da pausa:" isOpen={isOpenMotivoClickPausa} onConfirmAction={pauseControleDocaConfirmMotivoAsync} onCloseAction={() => setIsOpenMotivo(false)} /> : ''}
            {isOpenFinalizaDocaClickPlaca ? <ConfirmPopup message="Deseja finalizar a doca?" isOpen={isOpenFinalizaDocaClickPlaca} onConfirmAction={finalizaDocaConfirm} onCloseAction={() => setIsOpenFinalizaDoca(false)} /> : ''}
        </BasePage>
    );
}

export default ControleDocaPage;